import { store } from '../store'

export const message = (message: string | null, title?: string) => {
    setTimeout(() => store.dispatch({ type: `SET_ACTIVE_CONFIRM_MESSAGE`, message: message, title: title }), 0)
}
